<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/Edit.vue";

export default {
  name: "MobileStocksEdit",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Modifier stock",
    };
  },
};
</script>
